export default function ProblemSolution() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            Stop Searching Randomly. Start Using A Smarter Product Discovery System.
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
            Finding the right products online can be time-consuming. Vigorbuy Spreadsheet organizes product information into simple categories, helping users discover popular items, compare options, understand quality information, and make better purchasing decisions.
          </p>
        </div>
      </div>
    </section>
  );
}